import { render, staticRenderFns } from "./Detail-Leave.vue?vue&type=template&id=c5befb06&scoped=true"
import script from "./Detail-Leave.vue?vue&type=script&lang=js"
export * from "./Detail-Leave.vue?vue&type=script&lang=js"
import style0 from "./Detail-Leave.vue?vue&type=style&index=0&id=c5befb06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5befb06",
  null
  
)

export default component.exports